import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/user/project-detail.vue'
wx.createPage(MiniProgramPage)